import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What career opportunities are available in finance?",
    category: "Technology",
    description:
      "Finance offers roles like Financial Analyst, Investment Banker, Equity Research Analyst, Risk Manager, Accountant, Wealth Manager, Corporate Finance Associate, Credit Analyst, and Financial Planner across banks, corporations, and consulting firms.",
  },
  {
    title: "Why are financial statements important?",
    category: "Trending",
    description:
      "Financial statements help measure a company’s profitability, liquidity, and overall health. Investors and managers use balance sheets, income statements, and cash flow reports to assess performance and plan future strategies.",
  },
  {
    title: "Why is Excel important in finance?",
    category: "Design",
    description:
      "Excel is essential in finance for budgeting, forecasting, data analysis, financial modeling, and reporting. Its formulas, pivot tables, and automation features make it the most widely used tool in the industry.",
  },
  {
    title: "What tools do finance professionals commonly use?",
    category: "Design",
    description:
      "Finance professionals use Excel, Power BI, SAP, QuickBooks, Tally, Bloomberg Terminal, financial modeling tools, and databases for market analysis. These tools assist in budgeting, forecasting, reporting, and investment research.",
  },
  {
    title: "What skills are important for a finance career?",
    category: "Design",
    description:
      "Key skills include financial analysis, Excel proficiency, accounting basics, understanding statements, risk assessment, problem-solving, communication, and critical thinking. Knowledge of tools like Power BI or financial modeling is also beneficial.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
